import PropTypes from 'prop-types';

export default PropTypes.shape({
  response: PropTypes.shape({
    status: PropTypes.number,
  }),
});
